import { SkillModel } from '@/models/skill.model';
import { BaseModel } from '@/models/base.model';
import { TablePlatformSettingsModel } from './platform-settings.model';
import { ChallengeModel } from '@/models/challenge.model';
import { CountryModel } from '@/models/country.model';

export const DEFAULT_PROFILE_PICTURE = (
  require('@/assets/images/profile/no-avatar.svg')
);

export type UserTypes = 'contestant' | 'judge' | 'advisor' | 'partner';
export type ProfileTypes = 'student' | 'company';

export class UserModel extends BaseModel {
  constructor(
    public user_profile: UserProfileModel | null,
    public avatar: string | null,
    public first_name?: string,
    public last_name?: string,
    public full_name?: string,
    public slug?: string,
    public is_admin?: boolean,
    public email?: string,
    public roles?: UserTypes[],
    public role?: RoleModel,
    public confirmed_at?: string,
    public description?: string,
    public description_br?: string,
    public video?: string,
    public banner?: string,
    public flag?: string,
    public password?: string,
    public accept_terms?: boolean,
    public linkedIn?: string,
    public password_confirmation?: string,
    public address?: string,
    public skills?: SkillModel[],
    public contestant?: ProfileContestantModel,
    public platform_setting?: TablePlatformSettingsModel) {
    super()
  }

  get profilePicture() {
    return this.avatar || DEFAULT_PROFILE_PICTURE;
  }
}

export class SignInCredentials {
  constructor(
    public username: string,
    public password: string) {
  }
}

export class UserProfileModel {
  constructor(
    public birthdate?: string,
    public gender?: 'm' | 'f' | 'o',
    public about?: string,
    public created_at?: Date,
    public updated_at?: Date) {
  }
}

export class ProfileContestantModel extends BaseModel {
  constructor(
    public nationality?: CountryModel,
    public country_residence?: CountryModel,
    public location?: string,
    public latitude?: number,
    public longitude?: number,
    public user?: UserModel,
    public challenges?: ChallengeModel[],
    public types?: ProfileTypes,
    public skills?: SkillModel[]) {
    super()
  }
}

export class ProfileModel extends ProfileContestantModel {
  constructor(public user_profile?: UserProfileModel) {
    super();
  }
}

export class UserChangePasswordModel {
  constructor(
    public email?: string,
    public password?: string,
    public current_password?: string,
    public password_confirmation?: string) {
  }
}

export class UserUpdatePayload {
  constructor(
    public first_name?: string,
    public last_name?: string,
    public email?: string,
    public password?: string,
    public password_confirmation?: string) {
  }
}

export class StartupModel {
  constructor(
    public video?: string,
    public website?: string,
    public facebook?: string,
    public twitter?: string,
    public url_startup_logo?: string,
    public industry?: string,
    public name?: string,
    public elevator_pitch?: string,
    public creation_date?: string,
    public development_stage?: string,
    public city?: string,
    public phone?: string) {

  }
}

export class RoleModel extends BaseModel {
  constructor(public name?: string) {
    super()
  }
}
